module.exports = __webpack_public_path__ + "media/app/assets/avatar-2e37043bbb0da722752f97c484565b53.jpg";